<div class="outer-container">
  <div id="type-id-date-container">
    <h1>{{ 'material.compositeMaterial' | transloco }}</h1>
    <span *ngIf="compositeMaterial?.id != null; else elseHeader">
      <span class="grey"
        >({{ 'commonPackagingFields.id' | transloco }}: {{ compositeMaterial.id }}, {{ 'commonPackagingFields.creationDate' | transloco }}:
        {{ getLocaleDate(this.compositeMaterial.creationTimestamp) }})
      </span>
    </span>
    <ng-template #elseHeader>
      <div class="grey">{{ 'material.newMaterial' | transloco }}</div>
    </ng-template>
  </div>

  <div *ngIf="isFormLocked">
    <alert type="info">
      <div class="icon-text-container">
        <mat-icon class="gray-icon-18">info</mat-icon>
        {{ 'packagingUnit.messages.compositeMaterialLocked' | transloco }}
      </div>
    </alert>
  </div>

  <div *ngIf="isTracked && !isPreview">
    <alert type="info">
      <div class="icon-text-container">
        <mat-icon class="gray-icon-18">info</mat-icon>
        {{ 'material.messages.materialTracked' | transloco }}
      </div>
    </alert>
  </div>

  <div *ngIf="!isEditPermitted">
    <alert type="info">
      <div class="icon-text-container">
        <mat-icon class="gray-icon-18">info</mat-icon>
        {{ 'warnings.editNotPermitted' | transloco }}
      </div>
    </alert>
  </div>

  <mat-card *ngIf="isDataExchangeSubRequest && subRequestInfo" class="sub-request-comments-card">
    <mat-card-content>
      <div class="sub-request-card-title">
        {{ 'dataManagement.dataExchangeRequests.subRequest.infoTitle' | transloco }}
      </div>
      <div class="sub-request-status">
        <span class="sub-request-status-label">{{ 'dataManagement.dataExchangeRequests.subRequest.status' | transloco }}:</span>
        <span>{{ 'dataManagement.dataExchangeRequests.status.' + DataExchangeRequestStatusDto[subRequestInfo.subRequest.status] | transloco }}</span>
      </div>
      <mat-divider class="comments-divider"></mat-divider>
      <div *ngIf="subRequestInfo.parentComments?.length" class="sub-request-parent-comments">
        <p class="comments-section-subtitle">{{ 'dataManagement.dataExchangeRequests.comments.parentRequestTitle' | transloco }}</p>
        <app-data-exchange-comments [comments]="subRequestInfo.parentComments" [canAddComment]="false"> </app-data-exchange-comments>
        <mat-divider class="comments-divider"></mat-divider>
      </div>
      <div class="sub-request-comments">
        <p class="comments-section-subtitle">{{ 'dataManagement.dataExchangeRequests.comments.subRequestTitle' | transloco }}</p>
        <app-data-exchange-comments [comments]="subRequestInfo.subRequest.comments" (commentAdded)="onSubRequestCommentAdded($event)"> </app-data-exchange-comments>
      </div>
    </mat-card-content>
  </mat-card>

  <div [formGroup]="materialForm">
    <div class="flex-row flex-space-between version-tags-container">
      <div id="versions-container">
        <div (click)="loadHistoryVersions()" *ngIf="compositeMaterial.id != null && !isPreview && !isUserValidator">
          <mat-form-field class="form-field-versions">
            <mat-label class="label-large">{{ 'home.packagingUnitHome.historyVersion' | transloco }}</mat-label>
            <mat-select [(value)]="compositeMaterial.version" (selectionChange)="onHistoryVersionChange($event.value)">
              <mat-select-trigger>
                {{ 'common.text.version' | transloco }} {{ compositeMaterial.version }}
                <span *ngIf="compositeMaterial.versionName">({{ compositeMaterial.versionName }}) </span>
                {{ getDateTimeString(compositeMaterial.lastModificationTimestamp) }}
                <strong *ngIf="compositeMaterial.isCurrentVersion">({{ 'common.text.current' | transloco }})</strong>
              </mat-select-trigger>
              <mat-option *ngFor="let historyVersion of historyVersions" [value]="historyVersion.versionNumber">
                {{ 'common.text.version' | transloco }} {{ historyVersion.versionNumber }} <span *ngIf="historyVersion.versionName">({{ historyVersion.versionName }})</span>
                {{ getDateTimeString(historyVersion.creationTimestamp) }}
                <strong *ngIf="historyVersion.isCurrentVersion">({{ 'common.text.current' | transloco }})</strong>
                <span class="spinner-container">
                  <mat-spinner diameter="24" color="accent" *ngIf="spinnerActive"></mat-spinner>
                </span>
                <button mat-icon-button color="primary" (click)="editVersionName(historyVersion); $event.stopPropagation()">
                  <mat-icon class="version-edit-icon">edit</mat-icon>
                </button>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="packaging-tag-container">
        <app-select-tags [allTags]="allTags" [selectedTags]="selectedTags" *ngIf="!isPreview && !isUserValidator" (tagsChanged)="setTags()"> </app-select-tags>
      </div>
    </div>

    <app-relevant-calculation-selector [(relevantAnalysisTypes)]="relevantAnalysisTypes" />

    <mat-form-field class="full-width comment-form-field" appearance="outline">
      <mat-label>{{ 'packagingUnit.fields.comment' | transloco }}</mat-label>
      <textarea
        class="no-resize-textarea"
        matInput
        formControlName="comment"
        [maxlength]="maxCommentLength"
        placeholder="{{ 'packagingUnit.fields.commentMaxLength' | transloco: { length: maxCommentLength } }}">
      </textarea>
    </mat-form-field>

    <app-composite-material-html-template
      formControlName="multiMaterialControl"
      [isUserValidator]="isUserValidator"
      [isPreview]="isPreview"
      [isTracked]="isTracked"
      [canEditForm]="canEditForm"
      (manufacturingCountryChanged)="onManufacturingCountryChanged($event)"
      [(relevantAnalysisTypes)]="relevantAnalysisTypes">
    </app-composite-material-html-template>

    <div>
      <app-doc-upload-section [(areaDto)]="compositeMaterial.docArea" [isEditable]="canEditForm" [ppwrRelevant]="relevantAnalysisTypes.ppwrRelevant">
      </app-doc-upload-section>
    </div>

    <app-image-upload [canEditForm]="canEditForm" [images]="compositeMaterial.images" (filesEdited)="onFilesEdited()"> </app-image-upload>

    <app-certificate-upload [canEditForm]="canEditForm" [certificates]="compositeMaterial.certificates" [certificateTypes]="allCertificateTypes" (filesEdited)="onFilesEdited()">
    </app-certificate-upload>

    <app-pdf-upload [canEditForm]="canEditForm" [pdfs]="compositeMaterial.documents" (filesEdited)="onFilesEdited()"> </app-pdf-upload>

    <mat-card>
      <mat-card-content class="table-container-wide">
        <div id="table-container">
          <app-multi-material-table
            #materialsTable
            [parentCompositeMaterial]="compositeMaterial"
            [allMaterialFunctions]="allMaterialFunctions"
            [allColors]="handler.allColors"
            [allManifestations]="handler.allManifestations"
            [callerId]="callerId"
            [manufacturingCountry]="selectedManufacturingCountry"
            [packagingUnitTypeId]="packagingUnitTypeId"
            [canEditForm]="canEditForm"
            [isIndependentMaterial]="true"
            [isMassRequired]="false"
            (totalWeightChanged)="totalWeightChanged($event)"
            [(relevantAnalysisTypes)]="relevantAnalysisTypes"
            [allowLayerManipulation]="!isInternallyTracked"
            [isDataExchangeSubRequest]="isDataExchangeSubRequest">
          </app-multi-material-table>
        </div>
      </mat-card-content>
    </mat-card>

    <div id="version-name-container" *ngIf="canEditForm">
      <div id="version-name-label" class="label-large">
        {{ 'packagingUnit.messages.nameVersionLabel' | transloco }}
      </div>
      <div id="version-name-input">
        <mat-form-field class="form-field-medium">
          <mat-label class="label-large">{{ 'commonPackagingFields.versionName' | transloco }}</mat-label>
          <input formControlName="newVersionName" matInput autocomplete="off" />
        </mat-form-field>
      </div>
    </div>

    <button
      *ngIf="!isDataExchangeSubRequest || subRequestInfo?.isReceiver"
      (click)="onSubmit()"
      mat-raised-button
      color="primary"
      class="custom-button"
      [disabled]="!canEditForm || (isInOngoingDataExchange.length > 0 && !isDataExchangeSubRequest)"
      type="button">
      <mat-icon>save_alt</mat-icon>
      {{ 'common.buttons.save' | transloco }}
    </button>

    <button
      *ngIf="isDataExchangeSubRequest && subRequestInfo?.isReceiver"
      (click)="onFinishRequest()"
      mat-raised-button
      color="accent"
      [disabled]="!canEditForm"
      class="custom-button"
      type="button">
      <mat-icon>check_circle</mat-icon>
      {{ 'dataManagement.dataExchangeRequests.finishSubRequest' | transloco }}
    </button>

    <button
      *ngIf="isDataExchangeSubRequest && subRequestInfo?.isSender"
      [disabled]="subRequestInfo?.subRequest?.status !== DataExchangeRequestStatusDto.Submitted"
      (click)="onApproveSubRequest()"
      mat-raised-button
      color="accent"
      class="custom-button"
      type="button">
      <mat-icon>check_circle</mat-icon>
      {{ 'dataManagement.dataExchangeRequests.actions.approveSubRequest' | transloco }}
    </button>

    <button
      *ngIf="isDataExchangeSubRequest && subRequestInfo?.isSender"
      [disabled]="subRequestInfo?.subRequest?.status !== DataExchangeRequestStatusDto.Submitted"
      (click)="onReopenSubRequest()"
      mat-raised-button
      color="accent"
      class="custom-button"
      type="button">
      <mat-icon>replay</mat-icon>
      {{ 'dataManagement.dataExchangeRequests.actions.reopenSubRequest' | transloco }}
    </button>

    <button
      mat-raised-button
      color="primary"
      class="custom-button"
      type="button"
      *ngIf="!isDataExchangeSubRequest && !isPreview"
      [disabled]="compositeMaterial.id == null || isUserValidator"
      (click)="createDataExchangeRequest()">
      <mat-icon>swap_horiz</mat-icon>
      {{ 'dataManagement.directory.toolbar.createDataExchangeRequest' | transloco }}
    </button>
  </div>
</div>
